import RestrictionType from 'owa-service/lib/contract/RestrictionType';
import SearchExpressionType from 'owa-service/lib/contract/SearchExpressionType';
import andType from 'owa-service/lib/factory/and';
import constantType from 'owa-service/lib/factory/constant';
import fieldURIOrConstantType from 'owa-service/lib/factory/fieldURIOrConstantType';
import isGreaterOrEqualType from 'owa-service/lib/factory/isGreaterThanOrEqualTo';
import isLessOrEqualType from 'owa-service/lib/factory/isLessThanOrEqualTo';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import restrictionType from 'owa-service/lib/factory/restrictionType';

const defaultFieldUri = 'DateTimeReceived';
/**
 * Gets date search restrictions for search request
 */
export default function getSearchRestrictions(
    fromDate: Date,
    toDate: Date,
    upperBoundFieldUri: string,
    lowerBoundFieldUri: string
): RestrictionType {
    if (fromDate || toDate) {
        const searchExpressions: SearchExpressionType[] = [];

        /**
         * Generates the "before date" expression. If toDate is falsey, meaning
         * that the user only selected an "after date", default the "before date" value
         * to today (since all emails the user received will be from today or before).
         */
        searchExpressions.push(
            isLessOrEqualType({
                FieldURIOrConstant: fieldURIOrConstantType({
                    Item: constantType({
                        Value: toDate
                            ? toDate.toISOString().substring(0, 10)
                            : new Date().toISOString().substring(0, 10),
                    }),
                }),
                Item: propertyUri({
                    FieldURI: upperBoundFieldUri ? upperBoundFieldUri : defaultFieldUri,
                }),
            })
        );

        /**
         * Generates the "after date" expression. If fromDate is falsey, meaning
         * that the user only selected a "before date", default the "after date" value
         * to the earliest possible Date (since all email is guaranteed to have been
         * received after that date).
         */
        searchExpressions.push(
            isGreaterOrEqualType({
                FieldURIOrConstant: fieldURIOrConstantType({
                    Item: constantType({
                        Value: fromDate
                            ? fromDate.toISOString().substring(0, 10)
                            : new Date(0).toISOString().substring(0, 10),
                    }),
                }),
                Item: propertyUri({
                    FieldURI: lowerBoundFieldUri ? lowerBoundFieldUri : defaultFieldUri,
                }),
            })
        );

        const restrictions = andType({
            Items: searchExpressions,
        });

        return restrictionType({
            Item: restrictions,
        });
    } else {
        return null;
    }
}
